var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteDriverIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 31,
    fill: "#002CB1",
    stroke: "#D4F4FA",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 34.1668H29.5833V31.4168H27.75V34.1668H25V36.0002H27.75V38.7502H29.5833V36.0002H32.3333V34.1668ZM41.5 35.0835C43.0217 35.0835 44.2408 33.8552 44.2408 32.3335C44.2408 30.8118 43.0217 29.5835 41.5 29.5835C41.2067 29.5835 40.9225 29.6293 40.6658 29.7118C41.1883 30.4543 41.4908 31.3527 41.4908 32.3335C41.4908 33.3143 41.1792 34.2035 40.6658 34.9552C40.9225 35.0377 41.2067 35.0835 41.5 35.0835ZM36.9167 35.0835C38.4383 35.0835 39.6575 33.8552 39.6575 32.3335C39.6575 30.8118 38.4383 29.5835 36.9167 29.5835C35.395 29.5835 34.1667 30.8118 34.1667 32.3335C34.1667 33.8552 35.395 35.0835 36.9167 35.0835ZM42.985 37.0635C43.7458 37.7327 44.25 38.5852 44.25 39.6668V41.5002H47V39.6668C47 38.2552 44.8275 37.3843 42.985 37.0635ZM36.9167 36.9168C35.0833 36.9168 31.4167 37.8335 31.4167 39.6668V41.5002H42.4167V39.6668C42.4167 37.8335 38.75 36.9168 36.9167 36.9168Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteDriverIcon);
export default __webpack_public_path__ + "static/media/InviteDriverIcon.f7bb582e27403f003d5fb447addf81c3.svg";
export { ForwardRef as ReactComponent };